import { utilStyles } from '@Utils/utilStyles';
import { Text, View } from 'react-native';

export const MapPageError = () => (
  <View style={utilStyles.alignItemsCenter}>
    <Text>Error</Text>
    <Text>:-/</Text>
  </View>
);
